// The footer for the site
import React from 'react'
import '../Styles/Footer.css'
import logo from '../../Assets/CSUS_logo.png'
import discord from '../../Assets/icons/discord.svg'
import email from '../../Assets/icons/email.svg'
import fb from '../../Assets/icons/facebook.svg'
import instagram from '../../Assets/icons/instagram.svg'
import linkedin from '../../Assets/icons/linkedin.svg'

const Footer = () => {
    const baseUrl = window.location.origin;

    return (
        <div className="footer">
            <div className="footer-container">
                <div className="footer-left">
                <img className="footer-logo" src={logo} size="5"/>
                <p>CSUS represents Computer Science students at Western University.</p>
                <p className="copyright-text">© 2023 Computer Science Undergraduate Society. All rights reserved.</p>
                <div className="socials-logo-container">
                <a href="https://discord.gg/mgPQ97JHJb" target="_blank">
                    <img className="discord-logo" src={discord} alt="Discord" class="footer-socials"/>
                </a>
                <a href="https://www.linkedin.com/company/western-csus/" target="_blank">
                    <img className="linkedin-logo" src={linkedin} alt="LinkedIn" class="footer-socials"/>
                </a>
                <a href="https://www.instagram.com/westerncsus/" target="_blank">
                    <img className="instagram-logo" src={instagram} alt="Instagram" class="footer-socials"/>
                </a>
                <a href="https://www.facebook.com/westerncsus" target="_blank">
                    <img className="fb-logo" src={fb} alt="Facebook" class="footer-socials"/>
                </a>
                <a href="mailto:csusuwo@gmail.com" target="_blank">
                    <img className="email-logo" src={email} alt="Email" class="footer-socials"/>
                </a>
                </div>
                </div>
                <div className="footer-right">
                    <div className="footer-links">
                        <p className="link-title">Navigation</p>
                        <a href={`${baseUrl}/`}><p>About Us</p></a>
                        <a href={`${baseUrl}/#team`}><p>Meet the Team</p></a>
                        <a href={`${baseUrl}/#events`}><p>Our Events</p></a>
                        <a href={`${baseUrl}/#contact`}><p>Contact Us</p></a>
                        <a href={`${baseUrl}/#faq`}><p>FAQ</p></a>
                    </div>
                    <div className="footer-links">
                        <p className="link-title">Resources</p>
                        <p>Recruiting Resources</p>
                        <p>Class Reviews</p>
                        <p>Academic Help</p>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Footer
